// extracted by mini-css-extract-plugin
export default {"container":"sauce_container__qArzb","title":"sauce_title__PyPpU"};